import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
 private _url$ = new BehaviorSubject<string>('');   // runtime base
  url$ = this._url$.asObservable();

  private _beUrl$ = new BehaviorSubject<string>('');   // backend base
  beUrl$ = this._beUrl$.asObservable();

  setUrl(url: string) { this._url$.next(url ?? ''); }
  getUrl() { return this._url$.value; }

  setBEUrl(url: string) { this._beUrl$.next(url ?? ''); }
  getBEUrl() { return this._beUrl$.value; }

}
